import type { AliasMatchType } from '@/api/payees';

/** The alias dialog's type choice (TMMAPP-0124): a `REGEX` alias is a "Pattern". */
export type AliasKind = 'EXACT' | 'CONTAINS' | 'PATTERN';

export const ALIAS_KINDS: readonly AliasKind[] = ['EXACT', 'CONTAINS', 'PATTERN'];

/** Each type's catalog word: "Exact", "Contains", "Pattern". */
export const ALIAS_KIND_KEYS = {
  EXACT: 'aliasDialog.kind.EXACT',
  CONTAINS: 'aliasDialog.kind.CONTAINS',
  PATTERN: 'aliasDialog.kind.PATTERN',
} as const satisfies Record<AliasKind, string>;

export function kindOf(matchType: AliasMatchType): AliasKind {
  return matchType === 'REGEX' ? 'PATTERN' : matchType;
}
